/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DocumentFetcherDescription } from "./DocumentFetcherDescription";
import {
  DocumentFetcherDescriptionFromJSON,
  DocumentFetcherDescriptionFromJSONTyped,
  DocumentFetcherDescriptionToJSON,
  DocumentFetcherDescriptionToJSONTyped,
} from "./DocumentFetcherDescription";
import type { ShipmentDocumentVisibility } from "./ShipmentDocumentVisibility";
import {
  ShipmentDocumentVisibilityFromJSON,
  ShipmentDocumentVisibilityFromJSONTyped,
  ShipmentDocumentVisibilityToJSON,
  ShipmentDocumentVisibilityToJSONTyped,
} from "./ShipmentDocumentVisibility";

/**
 *
 * @export
 * @interface DocumentsTabData
 */
export interface DocumentsTabData {
  /**
   *
   * @type {Array<ShipmentDocumentVisibility>}
   * @memberof DocumentsTabData
   */
  documents: Array<ShipmentDocumentVisibility>;
  /**
   *
   * @type {DocumentFetcherDescription}
   * @memberof DocumentsTabData
   */
  documentFetcherDescription?: DocumentFetcherDescription | null;
}

/**
 * Check if a given object implements the DocumentsTabData interface.
 */
export function instanceOfDocumentsTabData(
  value: object,
): value is DocumentsTabData {
  if (!("documents" in value) || value["documents"] === undefined) return false;
  return true;
}

export function DocumentsTabDataFromJSON(json: any): DocumentsTabData {
  return DocumentsTabDataFromJSONTyped(json, false);
}

export function DocumentsTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentsTabData {
  if (json == null) {
    return json;
  }
  return {
    documents: (json["documents"] as Array<any>).map(
      ShipmentDocumentVisibilityFromJSON,
    ),
    documentFetcherDescription:
      json["documentFetcherDescription"] == null
        ? undefined
        : DocumentFetcherDescriptionFromJSON(
            json["documentFetcherDescription"],
          ),
  };
}

export function DocumentsTabDataToJSON(json: any): DocumentsTabData {
  return DocumentsTabDataToJSONTyped(json, false);
}

export function DocumentsTabDataToJSONTyped(
  value?: DocumentsTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    documents: (value["documents"] as Array<any>).map(
      ShipmentDocumentVisibilityToJSON,
    ),
    documentFetcherDescription: DocumentFetcherDescriptionToJSON(
      value["documentFetcherDescription"],
    ),
  };
}
